import type { IconData } from '../../types';

export const data: IconData = {
  o: '<path d="m378-347 356-355q12-12 28-12t29 12q12 12 12 29 0 16-12 28L406-261q-12 12-28 12t-28-12L169-442q-12-12-12-28 0-17 12-29t29-12q16 0 28 12l152 152Z"/>',
  f: '<path d="m378-347 356-355q12-12 28-12t29 12q12 12 12 29 0 16-12 28L406-261q-12 12-28 12t-28-12L169-442q-12-12-12-28 0-17 12-29t29-12q16 0 28 12l152 152Z"/>',
};

export default data;
